import React from 'react'
import styled from 'styled-components'
import { Pie } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

type PieWrapperProps = {
  width?: number
}
const PieWrapper = styled.div<PieWrapperProps>`
    width: ${({ width }) => `${width}px`};
`

const backgroundColors = [
  'rgba(153, 102, 255, 0.5)',
  'rgba(75, 192, 192, 0.5)',
  'rgba(255, 159, 64, 0.2)',
  'rgba(14, 1, 4, 0.2)',
  'rgba(54, 162, 235, 0.2)',
  'rgba(255, 206, 86, 0.2)',
]

const borderColors = [
  'rgba(153, 102, 255, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(255, 159, 64, 1)',
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
]

/* eslint-disable-next-line */
export interface IPieChartProps {
  data: number[],
  labels: string[],
  width?: number,
  valueType?: string,
  innerLabels?: boolean
}

export function PieChart({
  data, labels, width, valueType, innerLabels,
}: IPieChartProps):JSX.Element {
  return (
    <PieWrapper width={width}>
      <Pie
        data={{
          labels,
          datasets: [
            {
              label: '',
              data,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
            },
          ],
        }}
        options={{
          plugins:{
            datalabels: {
              display: innerLabels || false,
              color: 'white',
              font: {
                size: '16',
                weight: 'bold',
              },
              formatter(value: number) {
                switch (valueType) {
                  case 'percentages':
                    return `${value}%`
                  default:
                    return value
                }
              },
            },
          },

          maintainAspectRatio: false,
          legend: {
            display: false,
          },
        }}
        plugins={[ChartDataLabels]}
      />
    </PieWrapper>
  )
}

export default PieChart
